import React, { Component } from 'react';

import { Highlight, connectAutoComplete } from 'react-instantsearch-dom';
import AutoSuggest from 'react-autosuggest';

class AutoComplete extends Component {
  state = {
    value: this.props.currentRefinement,
  };

  onChange = (_, { newValue }) => {
    if (!newValue) {
      this.props.onSuggestionCleared();
    }

    this.setState({
      value: newValue,
    });
  };

  onSuggestionsClearRequested = () => {
    this.props.refine();
  };

  render() {
    const { hits, onSuggestionSelected } = this.props;
    const { value } = this.state;

    const inputProps = {
      placeholder: 'Search',
      onChange: this.onChange,
      value,
    };

    return (
      <AutoSuggest
        suggestions={hits}
        onSuggestionsFetchRequested={({ value }) => {
          this.props.refine(value);
        }}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        getSuggestionValue={hit => {
          return hit['How do I cancel my order?'];//modify
        }}
        renderSuggestion={hit => (
          <Highlight
            attribute="How do I cancel my order?"//modify
            hit={hit}
            tagName="mark"
          />
        )}
        inputProps={inputProps}
      />
    );
  }
}

export default connectAutoComplete(AutoComplete);



// WEBPACK FOOTER //
// ./src/AutoComplete.jsx